import styled, { css } from 'styled-components';

const GroupWorkspaceLoading = styled.div<{ extractedDesktopView: boolean }>`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: var(--background-secondary);
  height: 100vh;
  overflow: auto;
  scrollbar-width: none;
  ${(props: { extractedDesktopView: boolean }) =>
    props.extractedDesktopView &&
    css`
      /* height: calc(100dvh - 46px); */
      border: 0.5px solid var(--border-primary);
      border-radius: var(--border-radius-8);
      margin: 0px;
    `}
`;

export { GroupWorkspaceLoading };
